import { Injectable } from "@angular/core";

import { UtenteVO } from "@app/shared/vo/utenteVO";

import { MapperUtente } from "@app/shared/mapper/mapper-utente";

import { BehaviorSubject } from "rxjs";
import { env } from "@env/environment";
import { JwtHelperService } from "@auth0/angular-jwt";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { UtenteDTO } from "../dto/utenteDTO";
import { OrganoService } from "./organo.service";
import { UtenteJWTDTO } from "../dto/utente-jwtDTO";
import { TokenAutenticazioneVO } from "../vo/token-autenticazione-VO";
import { KeycloakService } from "keycloak-angular";
import { ProfiloVO } from "../vo/profiloVO";
import { MembroService } from "./membro.service";
import { MapperProfilo } from "../mapper/mapper-profilo";

@Injectable({
  providedIn: "root",
})
export class AutenticazioneService {
  private urlAuthUtente = env.API_URL_BASE + env.API_AUTENTICA_UTENTE;
  private urlUtentiProfilo = env.API_URL_BASE + env.API_UTENTI_PROFILO;
  // Observable utente sources
  private utenteSource = new BehaviorSubject<UtenteVO>(null);
  // Observable utente streams
  utenteAnnounced$ = this.utenteSource.asObservable();
  private istanzaAppKey = env.APP_KEY + btoa(window.location.pathname);

  private helper: JwtHelperService;

  constructor(
    private http: HttpClient,
    private mapperUtente: MapperUtente,
    private organoService: OrganoService,
    private keycloakService: KeycloakService,
    private membroService: MembroService,
    private mapperProfilo: MapperProfilo
  ) {
    this.helper = new JwtHelperService();
  }

  async getUserWithRoles(cf: string): Promise<UtenteVO> {
    let utenteDTO = await this.http
        .get<UtenteDTO>(this.urlAuthUtente + "PHYLUM/" + cf)
        .toPromise();
    console.log(
        "[AutenticazioneService.autenticaByJWT] utente JWT:",
        JSON.stringify(utenteDTO)
    );

    return this.mapperUtente.convertDtoToVo(utenteDTO);
  }


  async isUtenteEstensoreSettore(cf: string, cmu: string): Promise<boolean> {
    let utenteGescorDTO = await this.http
      .get<UtenteDTO>(
        this.urlAuthUtente + "EDOC/" + cf
      )
      .toPromise();
    console.log(
      "[AutenticazioneService.isUtenteEstensore] utente:",
      JSON.stringify(utenteGescorDTO)
    );
    let profiliUtenteVO: ProfiloVO[] = this.mapperProfilo.convertListDtoToVo(utenteGescorDTO.profili);

    return profiliUtenteVO.find(res => res.codice.includes("ESTEN") && (res.settori.findIndex(settore => settore.codice == cmu) != -1)) != undefined;

  }

  async isUtenteEstensoreLiquidazioneSettore(cf: string, cmu: string): Promise<boolean> {
    let utenteGescorDTO = await this.http
      .get<UtenteDTO>(
        this.urlAuthUtente + "EDOC/" + cf
      )
      .toPromise();
    console.log(
      "[AutenticazioneService.isUtenteEstensoreLiquidazione] utente:",
      JSON.stringify(utenteGescorDTO)
    );
    let profiliUtenteVO: ProfiloVO[] = this.mapperProfilo.convertListDtoToVo(utenteGescorDTO.profili);

    return profiliUtenteVO.find(res => res.codice.includes("ESTENLIQ") && (res.settori.findIndex(settore => settore.codice == cmu) != -1)) != undefined;

  }

  async autenticaByJWT(accessToken: string, refreshToken: string) {
    if (!accessToken) {
      sessionStorage.removeItem("utente");
      this.announceUtente();
      return;
    }
    console.log(
      "[AutenticazioneService.autenticaByJWT] autentica utente parsando il token jwt"
    );
    const decodedToken = this.helper.decodeToken(accessToken);
    const expirationDate = this.helper.getTokenExpirationDate(accessToken);
    const isExpired = this.helper.isTokenExpired(accessToken);
    console.log(
      "[AutenticazioneService.autenticaByJWT] decodedToken:",
      decodedToken
    );
    console.log(
      "[AutenticazioneService.autenticaByJWT] JSON.stringify(decodedToken):",
      JSON.stringify(decodedToken)
    );
    console.log(
      "[AutenticazioneService.autenticaByJWT] expirationDate:",
      expirationDate
    );
    console.log("[AutenticazioneService.autenticaByJWT] isExpired:", isExpired);
    let utenteJWTDTO: UtenteJWTDTO;
    utenteJWTDTO = JSON.parse(JSON.stringify(decodedToken));

    const cfToClean = decodedToken.preferred_username as string;
    const cf = cfToClean.replace("tinit-", "").toLocaleUpperCase();
    const utenteDTO = await this.http
      .get<UtenteDTO>(
        this.urlAuthUtente + "PHYLUM/" + cf
      )
      .toPromise();
    console.log(
      "[AutenticazioneService.autenticaByJWT] utente JWT:",
      JSON.stringify(utenteDTO)
    );
    const utenteVO: UtenteVO = this.mapperUtente.convertDtoToVo(utenteDTO);

    await this.impostaNomeCmuProfili(utenteVO);
    let listaCollegio = await this.membroService.listaMembri().toPromise();
    let membroCollegio = listaCollegio.find(res => res.codiceFiscale == utenteVO.id);
    if (membroCollegio) {
      let profilo: ProfiloVO = new ProfiloVO();
      profilo.codice = "COLLEGIO";
      profilo.nome = 'Membro del collegio revisori contabili';
      profilo.autorizzazioni = [];
      utenteVO.profili.push(profilo);
      utenteVO.nome = membroCollegio.nome;
      utenteVO.cognome = membroCollegio.cognome;
      utenteVO.isCollegio = true;
    }
    utenteVO.token = accessToken;
    console.log(
      "[AutenticazioneService.autenticaByJWT] utenteVO:",
      JSON.stringify(utenteVO)
    );
    sessionStorage.setItem("utente", JSON.stringify(utenteVO));
    console.log(
      "[AutenticazioneService.autenticaByJWT] Session Storage utente",
      JSON.stringify(sessionStorage.getItem("utente"))
    );
    this.announceUtente();
  }

  public logOut() {
    console.log("[autenticazioneService] logOut -- start ");
    if (env["oauth2LogoutMethod"] && env["oauth2LogoutMethod"] === "POST") {
      this.logoutPost();
    } else {
      this.logoutGet();
    }
  }

  logoutGet() {
    console.log("[autenticazioneService] logGet -- start ");
    this.keycloakService.logout();
    sessionStorage.clear();
    window.location.href =
      env.oauth2Logout +
      "?redirect_uri=" +
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname;
  }

  async logoutPost() {
    console.log("[autenticazioneService] logPost -- start ");
    const keycloak = await this.keycloakService.getKeycloakInstance();

    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + keycloak.token,
      }),
    };

    const body =
      "client_id=" +
      keycloak.clientId +
      "&refresh_token=" +
      keycloak.refreshToken;

    this.http.post(env.oauth2Logout, body, httpOptions).subscribe((data) => {
      console.log(data);
      sessionStorage.clear();
      window.location.reload();
    });
  }

  getUtente(): UtenteVO {
    const utente = JSON.parse(sessionStorage.getItem("utente"));
    return utente;
  }

  // Service message commands
  announceUtente() {
    const utente = JSON.parse(sessionStorage.getItem("utente"));
    console.log("annuncio utente -- service ", utente);
    this.utenteSource.next(utente);
  }

  async impostaNomeCmuProfili(utenteVO: UtenteVO) {
    for (let i = 0; utenteVO.profili && i < utenteVO.profili.length; i++) {
      const profilo = utenteVO.profili[i];
      // per come funziona il servizio c'è sempre solo un settore per profilo
      const settori = await this.organoService
        .getCMU(profilo.settori[0].codice)
        .toPromise();
      if (settori && settori.length > 0) {
        profilo.settori[0].nome = settori[0].nome;
      }
    }
  }
}
